// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KECl","requiredAsterisk":"Info_requiredAsterisk__5xbaN"};